export default __webpack_public_path__ + "static/media/arrow_icon_white.dd6aab16.svg";